import { UpdateProfileRequest } from '@/src/api/rtkQuery/profileApi'

interface FormValues {
    title: string
    firstName: string
    lastName: string
    gender: string
    dateOfBirth: string
    screenName: string
    email: string
    phoneCountryCode: string
    phoneNumber: string
    addressLine1: string
    city: string
    state: string
    postalCode: string
    country: string
}

export function buildProfileUpdatePayload(values: FormValues): UpdateProfileRequest {
    const addresses = [values.addressLine1, values.city, values.state, values.postalCode, values.country].some(Boolean)
        ? [
              {
                  street_address: values.addressLine1,
                  city: values.city,
                  state: values.state,
                  pincode: values.postalCode,
                  country: values.country
              }
          ]
        : []

    return {
        personal_data: {
            title: values.title,
            first_name: values.firstName,
            last_name: values.lastName,
            gender: values.gender || '',
            date_of_birth: values.dateOfBirth || null
        },
        contact_data: {
            emails: [{ email_id: values.email }],
            addresses,
            phone_numbers: [
                {
                    category: 'mobile',
                    phone_number_value: values.phoneNumber,
                    country_code: values.phoneCountryCode
                },
                {
                    category: 'landline',
                    phone_number_value: '',
                    country_code: ''
                },
                {
                    category: 'fax',
                    phone_number_value: '',
                    country_code: ''
                }
            ],
            requestOtp: null
        },
        screen_name: values.screenName
    }
}
